















import Vue from "vue";
import Component from "vue-class-component";
import { CrudService } from "../core/services/crudService";
import { Settings, SettingsService } from "../core/services/configService";
import { CustomerHelper } from "../crm/helpers/customerHelper";
import { ProgramPackTexts } from "./programPackTexts";
import ProgramPage from "../components/programs/ProgramPage.vue";
import ProgramHero from "../components/programs/ProgramHero.vue";
import ProgramMeta from "../components/programs/ProgramMeta.vue";
import ProgramPanel from "../components/programs/ProgramPanel.vue";
import ProgramColumns from "../components/programs/ProgramColumns.vue";
import ProgramProgress from "../components/programs/ProgramProgress.vue";
import ProgramReports from "../components/programs/ProgramReports.vue";

@Component({
  components: { ProgramPage, ProgramHero, ProgramMeta, ProgramPanel, ProgramColumns, ProgramProgress, ProgramReports },
})
export default class MyProgramPackPage extends Vue {
  enrollment: any = null;
  reports: any[] = [];
  loaded: boolean = false;
  texts = ProgramPackTexts;

  get emptyText(): string {
    return this.loaded && this.enrollment === null ? this.$t("This program is not available").toString() : "";
  }

  get done(): number {
    return ProgramPackTexts.done(this.enrollment);
  }

  get sessions(): number {
    return ProgramPackTexts.sessions(this.enrollment);
  }

  get summary(): string {
    return this.t("{0} done · {1} pending").replace("{0}", String(this.done)).replace("{1}", String(this.sessions - this.done));
  }

  get columns(): any[] {
    return this.enrollment.columns.map((col: any) => ({
      name: col.name,
      rows: col.cards
        .filter((k: any) => k.cardType === 0)
        .reduce((rows: any[], k: any) => rows.concat(ProgramPackTexts.sessionRows(this.t, this.enrollment, k)), []),
    }));
  }

  get items(): string[] {
    return ProgramPackTexts.itemNames(this.enrollment);
  }

  t(key: string): string {
    return this.$t(key).toString();
  }

  async mounted() {
    const url = `${Settings.HostName}/api/publicprogrampacks/customer/${CustomerHelper.getStoredCustomer()}/${this.$route.params.id}`;
    const data = await new CrudService().httpGet(url);
    this.enrollment = data && data.ok ? data.model : null;
    this.loaded = true;
    if (this.enrollment) {
      new SettingsService().setPageTitle(this.enrollment.name);
      const sent = await new CrudService().httpGet(`${Settings.HostName}/api/publicreports/customer/${CustomerHelper.getStoredCustomer()}`);
      this.reports = sent && sent.ok ? sent.data.filter((r: any) => r.customerProgramPackId === this.enrollment.id) : [];
    }
  }
}
